import React, { useEffect, useState } from "react";
import { QuestionsIF } from "./QuestionsIF";
import { buildGenderFeature } from "fe-common/patientCase/AgeAndGenderQFeatures";
import { GenderValue } from "shared";
import { DocQuestion } from "./DocQuestion";
import { styled } from "@mui/material";
import { MaleFemaleContainer } from "../uiControllers/MaleFemaleContainer";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { QuestionOptionsContainer } from "./layout/questionOptionsContainer";
import { useTranslate } from "../../hooks/useTranslate";
import { DisclaimerText } from "../uiControllers/disclaimerText";
import { MultiLanguageIconContainer } from "fe-web-components/rtl/rtlStyles";
import { usePatientFeatureFlags } from "../../hooks/usePatientFeatureFlags";
import clsx from "clsx";
import { PatientColorMap } from "../../layout/patientColorMap";

const GenderQuestionView = styled("div")({
  width: "100%",
});

const GenderPickerView = styled("div")({
  display: "flex",
  flexDirection: "column",
  "&.mini-view .male-female-container-view": {
    border: `1px solid ${PatientColorMap.DefaultDark}`,
    background: "white",
    color: PatientColorMap.Default,
    "&.selected": {
      backgroundColor: PatientColorMap.Selected,
    },
  },
  "&.mini-view .question-options-container": {
    background: "transparent",
    padding: 0,
  },
});

const LeftBubble = styled(MultiLanguageIconContainer)({});

const InfoIcon = styled("div")({
  cursor: "pointer",
  marginLeft: "5px",
});

const DisclaimerArea = styled("div")({});

const QuestionContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  width: "fit-content",
});

const SelectArea = styled("div")({
  display: "flex",
  justifyContent: "center",
});

const RightBubble = styled("div")({});

export const GenderQuestion = (props: QuestionsIF & { className?: string }) => {
  const isAnswered = props.answer !== null && props.answer !== undefined;

  const [selected, setSelected] = useState<GenderValue>(null);

  const [disclaimerOpen, setDisclaimerOpen] = useState<boolean>(false);

  const { translate } = useTranslate();

  useEffect(() => {
    if (props.answer === null || props.answer === undefined) {
      setSelected(null);
    }
  }, [props.answer]);

  const onSelect = (gender: GenderValue) => {
    if (!isAnswered) {
      props.onAnswer([buildGenderFeature(gender)], false, gender);
      setSelected(gender);
    }
  };

  const onClickDisclaimer = (event) => {
    setDisclaimerOpen(!disclaimerOpen);
  };

  const allowGenderDisclaimer = usePatientFeatureFlags("showGenderDisclaimer");

  return (
    <GenderQuestionView className={"gender-question"}>
      <QuestionContainer className={"gender-question-container"}>
        <DocQuestion
          text={translate("QUESTION_GENDER_NO_NAME")}
          miniView={props.miniView}
        />
        {allowGenderDisclaimer && !disclaimerOpen && !isAnswered && (
          <InfoIcon onClick={onClickDisclaimer}>
            <InfoOutlinedIcon />
          </InfoIcon>
        )}
      </QuestionContainer>
      {!isAnswered && (
        <GenderPickerView
          className={clsx(
            "gender-picker-view",
            props.className,
            props.miniView ? "mini-view" : "",
          )}
        >
          <QuestionOptionsContainer className={"question-options-container"}>
            <SelectArea>
              <LeftBubble>
                <MaleFemaleContainer
                  selected={selected === GenderValue.MALE}
                  disabled={isAnswered}
                  onClick={onSelect}
                  gender={GenderValue.MALE}
                />
              </LeftBubble>
              <RightBubble>
                <MaleFemaleContainer
                  selected={selected === GenderValue.FEMALE}
                  disabled={isAnswered}
                  onClick={onSelect}
                  gender={GenderValue.FEMALE}
                />
              </RightBubble>
            </SelectArea>
          </QuestionOptionsContainer>
          <DisclaimerArea>
            {disclaimerOpen && (
              <DisclaimerText
                disclaimerText={translate("GENDER_DISCLAIMER")}
                onCloseDisclaimer={onClickDisclaimer}
              />
            )}
          </DisclaimerArea>
        </GenderPickerView>
      )}
    </GenderQuestionView>
  );
};
